import { render, staticRenderFns } from "./SafetyMonitoringe.vue?vue&type=template&id=381cf2d0&scoped=true&"
import script from "./SafetyMonitoringe.vue?vue&type=script&lang=js&"
export * from "./SafetyMonitoringe.vue?vue&type=script&lang=js&"
import style0 from "./SafetyMonitoringe.vue?vue&type=style&index=0&id=381cf2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cf2d0",
  null
  
)

export default component.exports